<template>
  <v-row justify="center">
    <v-dialog v-model="openModal" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Data Karyawan</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Nama (wajib)"
                  required
                  v-model="formData.nama"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Status (wajib)"
                  required
                  v-model="formData.status"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  label="Telp"
                  required
                  v-model="formData.telp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Alamat"
                  required
                  v-model="formData.alamat"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  label="Keterangan"
                  required
                  v-model="formData.ket"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-select
                  :items="['Y', 'N']"
                  label="Aktif (wajib)"
                  required
                  v-model="formData.is_active"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Username"
                  v-model="formData.username"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field
                  label="Password"
                  type="password"
                  v-model="formData.password"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Tanggal Masuk"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="formData.tgl_masuk"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.tgl_masuk"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12">
                <div class="text-subtitle-2 mb-2">Hak Akses Menu</div>
                <v-treeview
                  v-model="formData.permissions"
                  :items="menuItems"
                  selectable
                  selected-color="primary"
                  item-key="to"
                  item-text="title"
                  open-all
                  dense
                ></v-treeview>
              </v-col>
              <v-col cols="12" sm="6">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      label="Tanggal Keluar"
                      persistent-hint
                      prepend-icon="mdi-calendar"
                      v-bind="attrs"
                      v-on="on"
                      v-model="formData.tgl_keluar"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="formData.tgl_keluar"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            :disabled="loading"
            tabindex="-1"
            @click="
              $emit('close-modal');
              resetFormData();
            "
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            :loading="loading"
            text
            @click="updateData"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import store from "@/store";

export default {
  name: "EditModal",
  props: ["openModal", "id"],
  data() {
    return {
      formData: {
        nama: "",
        status: "",
        alamat: "",
        telp: "",
        ket: "",
        is_active: "",
        tgl_masuk: "",
        tgl_keluar: "",
        username: "",
        password: "",
        permissions: []
      },
      menu1: false,
      menu2: false,
      loading: false
    };
  },
  computed: {
    menuItems() {
      return store.state.app.items
        .filter(i => i.items && i.items.length)
        .map(i => ({
          to: i.to,
          title: i.title,
          children: i.items.map(s => ({ to: s.to, title: s.title }))
        }));
    }
  },
  watch: {
    openModal(val) {
      if (val) {
        this.fetchData();
      }
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;

      await axios
        .get(`karyawan/${this.id}`)
        .then(res => {
          this.formData.nama = res.data.nama;
          this.formData.status = res.data.status;
          this.formData.alamat = res.data.alamat;
          this.formData.telp = res.data.telp;
          this.formData.ket = res.data.ket;
          this.formData.is_active = res.data.is_active;
          this.formData.tgl_masuk = res.data.tgl_masuk;
          this.formData.tgl_keluar = res.data.tgl_keluar;
          this.formData.username = res.data.username;
          this.formData.permissions = Array.isArray(res.data.permissions)
            ? res.data.permissions
            : typeof res.data.permissions === "string"
            ? JSON.parse(res.data.permissions || "[]")
            : [];

          this.loading = false;
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    async updateData() {
      this.loading = true;

      await axios
        .put(`karyawan/${this.id}`, this.formData)
        .then(res => {
          this.loading = false;
          this.$emit("close-modal");

          this.resetFormData();
        })
        .catch(err => {
          this.loading = false;

          alert(err.response.data.message);
        });
    },
    resetFormData() {
      this.formData.nama = "";
      this.formData.status = "";
      this.formData.alamat = "";
      this.formData.telp = "";
      this.formData.ket = "";
      this.formData.is_active = "";
      this.formData.tgl_masuk = "";
      this.formData.tgl_keluar = "";
      this.formData.username = "";
      this.formData.password = "";
      this.formData.permissions = [];
    }
  }
};
</script>
